import { render, staticRenderFns } from "./v-table.vue?vue&type=template&id=67fd319f"
import script from "./v-table.vue?vue&type=script&lang=js"
export * from "./v-table.vue?vue&type=script&lang=js"
import style0 from "./v-table.vue?vue&type=style&index=0&id=67fd319f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports